
import  axios  from 'axios';
import {getSingleUser, loadSingleUserDataInStore} from "../user/actions";
import {loadCompanysDataWithUserId} from "../company";
import {CLEAR_A_TOWJOB_ERROR_MESSAGE, clearTowErrorMsgInStore, loadTowjobDataInStore} from "../towjob/actions";
import AppUtils from "../../../utils/AppUtils";
import {loadStoragelotDataInStore} from "../storagelot/actions";


export const LOAD_TOWCOMPANYDRIVER_DATA = 'towcompanydriver/LOAD_TOWCOMPANYDRIVER_DATA';
export const DELETE_A_TOWCOMPANYDRIVER = 'towcompanydriver/DELETE_A_TOWCOMPANYDRIVER';
export const SAVE_A_TOWCOMPANYDRIVER = 'towcompanydriver/SAVE_A_TOWCOMPANYDRIVER';
export const UPDATE_A_TOWCOMPANYDRIVER = 'towcompanydriver/UPDATE_A_TOWCOMPANYDRIVER';
export const CLEAR_A_TOWCOMPANYDRIVER_ERROR_MESSAGE = 'towcompanydriver/CLEAR_A_TOWCOMPANYDRIVER_ERROR_MESSAGE';


export function clearTowCompanyDriverErrorMsgInStore(){
    return {
        type: CLEAR_A_TOWCOMPANYDRIVER_ERROR_MESSAGE,
        
    }
}

export function loadTowCompanyDriverDataInStore(argTowCompanyDriverDataArray) {
    return {
        type: LOAD_TOWCOMPANYDRIVER_DATA,
        towCompanyDriversData:argTowCompanyDriverDataArray
    }
}
export function deleteATowCompanyDriverInStore(argDeleteResponse, argErrorMsg) {
    return {
        type: DELETE_A_TOWCOMPANYDRIVER,
        deleteTowCompanyDriverResponse:argDeleteResponse,
        errorMsg:argErrorMsg
    }
}

export function saveATowCompanyDriverDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: SAVE_A_TOWCOMPANYDRIVER,
        saveTowCompanyDriverResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function updateATowCompanyDriverDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: UPDATE_A_TOWCOMPANYDRIVER,
        updateTowCompanyDriverResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

/********************* End of InStore calls **************************/


export function addDriverToDriversArray(argTruck ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempTruckArray=[] ;
        tempTruckArray = Object.assign(tempTruckArray,state.towcompanydriver.towcompanydriversArray);
        //removig the match element with the matching id.
        let newDriverArray = tempTruckArray.filter(element => { return element.id !== argTruck.id });
        
        //adding to the top of the array.
        newDriverArray.unshift(argTruck);
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadTowCompanyDriverDataInStore(newDriverArray));
    }//end of return
}


export function deleteDriverFromDriversArray(argTruckId ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempTruckArray=[] ;
        tempTruckArray = Object.assign(tempTruckArray,state.towcompanydriver.towcompanydriversArray);
        //removig the match element with the matching id.
        let newArray = tempTruckArray.filter(element => { return element.id != argTruckId });
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadTowCompanyDriverDataInStore(newArray));
    }//end of return
}

export function updateDriverInDriversArray(argTruck ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempTruckArray=[] ;
        tempTruckArray = Object.assign(tempTruckArray,state.towcompanydriver.towcompanydriversArray);//storagelot.storagelotsArray);
        //rempoving the item from the array and then add the updated one to the array array.
        let newArray = tempTruckArray.filter(element => { return element.id != argTruck.id });
        //adding to the top of the array.
        newArray.unshift(argTruck);
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadTowCompanyDriverDataInStore(newArray));
    }//end of return
}

//****************************************
//Below is for update a Stream
//****************************************

export function clearTowCompanyDriverErrorMsg(){
    return (dispatch, getState) => {
        dispatch(clearTowCompanyDriverErrorMsgInStore());
    }
}

export function updateATowCompanyDriver(argURL, argCamera, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        updateATowCompanyDriverOnServer(argURL, argCamera, argCompanyId ,state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(updateATowCompanyDriverDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));
            dispatch(loadTowCompanyDriversData(argURL, argCompanyId));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            console.log("I had an error saving a towcompanydriver" + errorObj.statusText + errorObj.status);
            dispatch(updateATowCompanyDriverDataInStore({}, errorObj));
        });
    }//end of return
}


function updateATowCompanyDriverOnServer( argURL, argCamera, argCompanyId ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPutsForUpdateATowCompanyDriver(argURL, argCamera, argCompanyId ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                //console.log("Farshid some error occured on saving a TowCompanyDriver " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPutsForUpdateATowCompanyDriver(argURL, argTowCompanyDriver,argCompanyId ,argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/towcompanydrivers" ;
    console.log(" on posting a towcompanydriver the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.put(baseUrl,argTowCompanyDriver, {headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveATowCompanyDriver(argURL, argCamera,argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        saveATowCompanyDriverOnServer(argURL, argCamera,argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(saveATowCompanyDriverDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));
            dispatch(loadTowCompanyDriversData(argURL, argCompanyId));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
           console.log("I had an error saving a storage lot" + + errorObj.statusText + errorObj.status);
            dispatch(saveATowCompanyDriverDataInStore({}, errorObj));
        });
    }//end of return
}


function saveATowCompanyDriverOnServer( argURL, argCamera, argCompanyId  ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForSaveATowCompanyDriver(argURL, argCamera, argCompanyId  ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                //console.log("Farshid some error occured on saving a towcompanydriver " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPostsForSaveATowCompanyDriver(argURL, argCamera, argCompanyId ,argIdToken, argUserId){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/towcompanydrivers";
    console.log(" on posting a towcompanydriver the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argCamera ,{headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for delete a company
//****************************************
export function deleteATowCompanyDriver(argURL, argCameraId, argCompanyId ) {
    return (dispatch, getState) => {
        const state = getState();
        deleteATowCompanyDriverOnServer(argURL, argCameraId,argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(deleteResponse){
            //dispatch(loadTowCompanyDriversData(argURL, argCompanyId));
            dispatch(deleteATowCompanyDriverInStore(deleteResponse.data, {"status":deleteResponse.status, "statusText":deleteResponse.statusText}));
            dispatch(loadTowCompanyDriversData(argURL, argCameraId));
           
        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            //console.log("I had an error gettting Stream Data2" + err);
            dispatch(deleteATowCompanyDriverInStore({}, errorObj));
        });
    }//end of return
}


function deleteATowCompanyDriverOnServer( argURL, argStreamId,argCompanyId,  argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){



        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfDeletesForDeleteATowCompanyDriver(argURL, argStreamId, argCompanyId , argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                console.log("Farshid some error occured on deleteing a TowCompanyDriver " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfDeletesForDeleteATowCompanyDriver(argURL, argRealCompanyId, argStorageId, argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/cameras
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies"+"/"+argRealCompanyId+"/towcompanydrivers/"+argStorageId;
    console.log(" on deleteing a TowCompanyDriver the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.delete(baseUrl, {headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}


//Get list of companys
/*
export function loadTowCompanyDriversData(argURL, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        getListOfTowCompanyDrivers(argURL, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(companysList){

            dispatch(loadTowCompanyDriverDataInStore(companysList));

    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}
*/

export function loadTowCompanyDriversData(argURL, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        
        if((state.user.saveUserResp == null) ||(state.user.saveUserResp.id == null) || (state.user.saveUserResp.id == undefined)) {
            getSingleUser(argURL, state.login.loginData.idToken).then(function(userData){
                
                // dispatch(loadTowjobDataInStore(companysList));
                dispatch(loadSingleUserDataInStore(userData));
                dispatch(loadCompanysDataWithUserId(argURL,userData.id ));
    
               //getListOfTowCompanyDrivers(argURL, state.company.selectedCompany, state.login.loginData.idToken, userData.id).then(function(companysList){
                    getListOfTowCompanyDrivers(argURL, argCompanyId, state.login.loginData.idToken, userData.id).then(function(companysList){
                    
                    dispatch(loadTowCompanyDriverDataInStore(companysList));
                    
                }, function(err){
                    console.log("I had an error gettting loadTowjobsData" + err);
                });
                
            }, function(err){
                console.log("I had an error gettting Farms Data2" + err);
            });
            
            
            
            
        }else{
            getListOfTowCompanyDrivers(argURL, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(companysList){
                
                dispatch(loadTowCompanyDriverDataInStore(companysList));
                
            }, function(err){
                console.log("I had an error gettting loadTowjobsData" + err);
            })};
    }//end of return
}












function getArrayOfGetsForListOfTowCompanyDrivers(argURL,argCompanyId ,argIdToken, argUserId  ){
    /*
     I build something like this :
     http://localhost:4567/company
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/towcompanydrivers";
    console.log(" on getting list of TowCompanyDrivers  the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}

function getListOfTowCompanyDrivers( argURL, argCompanyId ,argIdToken, argUserId ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfTowCompanyDrivers(argURL, argCompanyId ,argIdToken, argUserId )).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on getting list of Storage " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



